export default __webpack_public_path__ + "static/media/facebook.8ef2f9dd.svg";